import React from 'react';
import styles from './Content.m.sass';

export default function Content({children}) {
  return (
    <div className={styles.content}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/content/Content.js